module.exports = __webpack_public_path__ + "img/repair.84470e59.png";